<template>
    <div class="base-wallet" :class="{'wallet-sp': $store.state.screen == 1}">
        <div class="header">
            <div class="back-img" @click="$router.back()">
                <img class="back" src="~images/back.png" />
            </div>
            <div class="title">我的钱包</div>
            <div class="service-img" @click="$router.push('/base-service')">
                <img class="ser" src="~images/user_service.png" />
            </div>
        </div>
        <div class="content">
            <div v-if="isblank == true">
                <div class="list" v-for="(item, index) in list" :key="index">
                    <div class="left">
                        <div>
                            <div class="currency" v-if="item.type == 1">我的金币：<span>{{item.num}}</span></div>
                            <div class="currency" v-else>我的平台币：<span>{{item.num}}</span></div>
                        </div>
                        <div>
                            <div class="ratio" v-if="item.type == 1">兑换比例：1金币={{item.rmb}}RMB</div>
                            <div class="ratio" v-else>充值比例：1平台币={{item.rmb}}RMB</div>
                        </div>
                    </div>
                    <div class="btn" @click="toRecharge(item)">
                        <span v-if="item.type == 1">赚取金币</span>
                        <span v-else>充值</span>
                    </div>
                </div>
            </div>
            <div class="theblank" v-if="isblank == false">
                <TheBlank />
            </div>
        </div>
    </div>
</template>

<script>
    import TheBlank from '@/components/TheBlank'

    export default {
        name: 'BaseWallet',
        components: {
            TheBlank
        },
        data () {
            return {
                accountData: {},
                h5LoginData:{},
                list: [],
                isblank: null
            }
        },
        methods: {
            toRecharge (item) {
                if (item.type != 1) {
                    this.$router.push('/base-recharge?num=' + item.num + '&rmb=' + item.rmb)
                } 
                // else {
                    // if(this.config.system == 2){
                    //     window.webkit.messageHandlers.wz_callOC.postMessage({method : 'makeMoney'})
                    // } else {
                    //     window.Android.makeMoney()
                    // }
                // }
            },
            // 获取钱包列表
            getProperty () {
                let options = {
                    uid: this.uid ? this.uid : this.accountData.uid,
                    appid: this.appid ? this.appid : this.h5LoginData.appid
                }
                console.log(this.h5LoginData.appid,111111111);
                options.sign = this.util.getSign(options, this.accountData.appkey ? this.accountData.appkey : this.h5LoginData.appkey )
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=userbox&a=property', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.list = res.data.data
                        this.isblank = this.list.length > 0 ? true : false
                        sessionStorage.setItem('setWallet', JSON.stringify(this.list))
                    }
                })
            }
        },
        created () {
            this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
            this.h5LoginData = JSON.parse(sessionStorage.getItem('h5LoginData'))
            this.getProperty()
            if (sessionStorage.getItem('setWallet')) {
                let setWallet = JSON.parse(sessionStorage.getItem('setWallet'))
                this.list = setWallet
                this.isblank = setWallet.length > 0 ? true : false
            } 
            // else {
            //     this.getProperty()
            // }
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22;
    // 横屏css
    .base-wallet {
        width: 1080px;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        transition: all 0.3s;
        .header {
            height: 132px;
            background: rgba($color, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .back-img {
                width: 192px;
                height: 132px;
                position: absolute;
                left: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .back {
                    width: 72px;
                    height: 72px;
                }
            }
            .title {
                font-size: 51px;
                text-align: center;
            }
            .service-img {
                width: 192px;
                height: 132px;
                position: absolute;
                right: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .ser {
                    width: 72px;
                    height: 72px;
                }
            }
        }
        .content {
            flex: 1;
            overflow-y: scroll;
            padding: 60px;
            position: relative;
            .list {
                height: 210px;
                border-radius: 18px;
                background: rgba(255, 255, 255, 0.2);
                margin-top: 30px;
                padding: 0 45px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .currency {
                    font-size: 36px;
                }
                .currency span {
                    font-size: 60px;
                }
                .ratio {
                    font-size: 30px;
                    color: rgba(255, 255, 255, 0.5);
                    margin-top: 26px;
                }
                .btn {
                    width: 180px;
                    height: 72px;
                    font-size: 36px;
                    border-radius: 6px;
                    background: $color;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
            .list:first-child {
                margin-top: 0;
            }
            .theblank {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }
    // 竖屏css
    .wallet-sp {
        width: 100%;
        height: 100%;
        .header {
            height: 240px;
            border-radius: 60px 0 0 0;
            .back-img {
                width: 290px;
                height: 240px;
                .back {
                    width: 130px;
                    height: 130px;
                }
            }
            .title {
                font-size: 92px;
            }
            .service-img {
                width: 290px;
                height: 240px;
                .ser {
                    width: 130px;
                    height: 130px;
                }
            }
        }
        .content {
            padding: 90px;
            .list {
                height: 300px;
                border-radius: 32px;
                margin-top: 54px;
                padding: 0 60px;
                .currency {
                    font-size: 60px;
                }
                .currency span {
                    font-size: 100px;
                }
                .ratio {
                    font-size: 60px;
                    margin-top: 10px;
                }
                .btn {
                    width: 327px;
                    height: 130px;
                    font-size: 60px;
                    border-radius: 10px;
                }
            }
        }
    }
</style>